import { render, staticRenderFns } from "./SidebarEditProfile.vue?vue&type=template&id=8659eeb6&scoped=true&"
import script from "./SidebarEditProfile.vue?vue&type=script&lang=js&"
export * from "./SidebarEditProfile.vue?vue&type=script&lang=js&"
import style0 from "./SidebarEditProfile.vue?vue&type=style&index=0&id=8659eeb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8659eeb6",
  null
  
)

export default component.exports